import { useGetLatestMembership } from '#api/member';
import { XButton } from '#assets/svg';
import { Text } from '#atoms';
import { PATH } from '#const/path';
import { Modal } from '#molecules';
import { Button } from '#pages/DashboardCustomer/styles';
import { useState } from 'react';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router';

export const AddButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => {
          TagManager.dataLayer({
            dataLayer: {
              event: 'customer_membershipadd_click',
              category: '회원관리',
              action: 'customer_membershipadd_click',
              value: 2
            }
          });
          setIsModalOpen(true);
        }}
        className="w-full h-[54px] px-10 py-4 bg-[#2e2a3a] rounded-lg justify-center items-center gap-1 inline-flex"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M9.6665 10.8332H4.6665V9.1665H9.6665V4.1665H11.3332V9.1665H16.3332V10.8332H11.3332V15.8332H9.6665V10.8332Z"
            fill="#BCB8C4"
          />
        </svg>
        <div className="text-[#bcb8c3] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
          수강권 추가
        </div>
      </div>

      {isModalOpen && <AddButtonModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

interface ModalProps {
  onClose: () => void;
}
const AddButtonModal = ({ onClose }: ModalProps) => {
  const navigate = useNavigate();

  const personId = sessionStorage.getItem('personId');

  const { data } = useGetLatestMembership(personId || '');

  const onNewWrite = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'customer_membershipadd_new_click',
        category: '회원관리',
        action: 'customer_membershipadd_new_click',
        value: 2
      }
    });
    onClose();
    navigate(`${PATH.DASHBOARD_CUSTOMER_MEMBERSHIP}/${personId}`);
  };

  const onLoad = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'customer_membershipadd_import_click',
        category: '회원관리',
        action: 'customer_membershipadd_import_click',
        value: 2
      }
    });
    onClose();
    navigate(`${PATH.DASHBOARD_CUSTOMER_MEMBERSHIP}/${personId}?load=true`);
  };

  return (
    <Modal onClose={onClose}>
      <div className="flex justify-between w-full">
        <Text textStyle="t3">수강권 추가</Text>
        <XButton onClick={onClose} />
      </div>

      <div className="w-full flex flex-col gap-8">
        <Button onClick={onNewWrite}>
          <div className="title">새로 작성</div>
          <div className="desc">수강권 내용을 새로 작성합니다</div>
        </Button>
        {data !== null && (
          <Button onClick={onLoad}>
            <div className="title">불러오기</div>
            <div className="desc">
              가장 최근에 추가된 수강권 내용을 <br />
              불러옵니다
            </div>
          </Button>
        )}
      </div>
    </Modal>
  );
};
